import { Seo } from "@/components/Seo";
import { LegalLayout } from "@/components/SiteFooter";
import site from "@/content/site.json";

const E = site.editorial;

export default function EditorialPolicy() {
  return (
    <LegalLayout title={E.title} updated="2026-10-26">
      <Seo title={E.title} description={E.description} path="/editorial-policy" />
      <div data-testid="editorial-policy-body">
        {E.sections.map((s) => (
          <section key={s.h}>
            <h2>{s.h}</h2>
            {s.p.map((p) => <p key={p.slice(0, 24)}>{p}</p>)}
          </section>
        ))}
      </div>
    </LegalLayout>
  );
}
